"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reusableFields = require("egov-ui-kit/config/forms/specs/PropertyTaxPay/utils/reusableFields");

var _actions = require("egov-ui-kit/redux/app/actions");

var _actions2 = require("egov-ui-kit/redux/common/actions");

var _actions3 = require("egov-ui-kit/redux/form/actions");

var _actions4 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _commons = require("egov-ui-kit/utils/commons");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _filter = require("lodash/filter");

var _filter2 = _interopRequireDefault(_filter);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _sortBy = require("lodash/sortBy");

var _sortBy2 = _interopRequireDefault(_sortBy);

var _utils = require("egov-ui-framework/ui-config/screens/specs/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "propertyRegistrationDetails",
  fields: {
    dag: {
      id: "dag",
      jsonPath: "Properties[0].registrationDetails.dag",
      required: false,
      labelsFromLocalisation: true,
      type: "textfield",
      floatingLabelText: "Dag",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      fullWidth: true,
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.dag", field.value));
      }
    },

    khatian: {
      id: "khatian",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.khatian",
      floatingLabelText: "Khatian",
      numcols: 6,
      required: false,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_KHATIAN_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.khatian", field.value));
      }
    },

    mouza: {
      id: "mouza",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.mouza",
      floatingLabelText: "Mouza",
      numcols: 6,
      required: false,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_MOUZA_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.mouza", field.value));
      }
    },

    queryNo: {
      id: "queryNo",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.queryNo",
      floatingLabelText: "Query Number",
      numcols: 6,
      required: false,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_QUERY_NO_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.queryNo", field.value));
      }
    },

    queryYear: {
      id: "queryYear",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.queryYear",
      floatingLabelText: "Query Year",
      numcols: 6,
      required: false,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_QUERY_YEAR_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.queryYear", field.value));
      }
    },

    deedNo: {
      id: "deedNo",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.deedNo",
      floatingLabelText: "Deed Number",
      numcols: 6,
      required: false,

      errorMessage: "PT_DEED_NO_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.deedNo", field.value));
      }
    },

    deedYear: {
      id: "deedYear",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.deedYear",
      floatingLabelText: "Deed Year",
      numcols: 6,
      required: false,

      errorMessage: "PT_DEED_YEAR_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.deedYear", field.value));
      }
    },

    location: {
      id: "location",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.location",
      floatingLabelText: "Location",
      numcols: 6,
      required: false,

      errorMessage: "PT_LOCATION_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.location", field.value));
      }
    },

    ro: {
      id: "ro",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.ro",
      floatingLabelText: "RO",
      numcols: 6,
      required: false,
      errorMessage: "PT_RO_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.ro", field.value));
      }
    },

    book: {
      id: "book",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.book",
      floatingLabelText: "Book",
      numcols: 6,
      required: false,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_BOOK_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        if (field.value) dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.book", field.value));
      }
    }
  },

  afterInitForm: function afterInitForm(action, store, dispatch) {
    function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var urlParams = getParameterByName("isInspection");
    if (urlParams == "yes") {
      var state = store.getState();
      var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties");

      if (data && data.length > 0) {
        var registrationDetails = data[0].registrationDetails;
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "dag", "value", registrationDetails.dag ? registrationDetails.dag : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "khatian", "value", registrationDetails.khatian ? registrationDetails.khatian : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "mouza", "value", registrationDetails.mouza ? registrationDetails.mouza : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "queryNo", "value", registrationDetails.queryNo ? registrationDetails.queryNo : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "queryYear", "value", registrationDetails.queryYear ? registrationDetails.queryYear : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "deedNo", "value", registrationDetails.deedNo ? registrationDetails.deedNo : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "deedYear", "value", registrationDetails.deedYear ? registrationDetails.deedYear : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "location", "value", registrationDetails.location ? registrationDetails.location : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "ro", "value", registrationDetails.ro ? registrationDetails.ro : ""));
        dispatch((0, _actions3.setFieldProperty)("propertyRegistrationDetails", "book", "value", registrationDetails.book ? registrationDetails.book : ""));

        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.characterofPremises", registrationDetails.characterofPremises ? registrationDetails.characterofPremises : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.dag", registrationDetails.dag ? registrationDetails.dag : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.khatian", registrationDetails.khatian ? registrationDetails.khatian : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.mouza", registrationDetails.mouza ? registrationDetails.mouza : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.queryNo", registrationDetails.queryNo ? registrationDetails.queryNo : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.queryYear", registrationDetails.queryYear ? registrationDetails.queryYear : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.deedNo", registrationDetails.deedNo ? registrationDetails.deedNo : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.deedYear", registrationDetails.deedYear ? registrationDetails.deedYear : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.location", registrationDetails.location ? registrationDetails.location : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.ro", registrationDetails.ro ? registrationDetails.ro : ""));
        dispatch((0, _actions4.prepareFinalObject)("Properties[0].registrationDetails.book", registrationDetails.book ? registrationDetails.book : ""));
      }
    }
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/propertyRegistrationDetails.js
// module id = 1891
// module chunks = 1137